/** Open a blob in a new browser tab (e.g. invoice PDF). Returns false if the popup was blocked. */
export const openBlobInNewTab = (blob: Blob): boolean => {
  const url = URL.createObjectURL(blob);
  const opened = window.open(url, '_blank', 'noopener,noreferrer');
  if (!opened) {
    URL.revokeObjectURL(url);
    return false;
  }
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
  return true;
};
